//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class OCRReceiptInputItem extends ItemBase {
    CashID: string | null = null;
    Filename: string | null = null;
    OriginalOCR: string | null = null;
    OCRProvider: string | null = null;

    constructor(initializer?: Partial<OCRReceiptInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OCRReceiptInputItem";
}
